module.exports = __webpack_public_path__ + "static/media/delete-badge.20a8ab7f.svg";